import { Link } from 'react-router-dom';
import RoundedCancleIcon from '../../../../components/ModalFormComp/RoundedCancleIcon';
import ChangePasswordIconChecked from '../../../../svgs/ChangePasswordIconChecked';
import StyledButton from '../../../../components/StyledButton';

import styles from './PasswordChangeSuccessModal.module.scss';

const PasswordChangeSuccessModal = ({ closeModal }: any) => (
  <div className={styles?.wrapper}>
    <div className={styles?.wrapper__icon}>
      <RoundedCancleIcon closeModal={closeModal} />
    </div>
    <div className={styles?.wrapper__checkedWrapper}>
      <ChangePasswordIconChecked />
    </div>
    <div className={styles?.wrapper__textWrapper}>
      <div className={styles?.wrapper__title}>Password Changed</div>
      <div className={styles?.wrapper__subTitle}>
        Your password has been changed successfully. You can now log in to the Admin Dashboard.
      </div>
      <Link to="/">
        <StyledButton name="Login" width="100%" border="none" backgroundColor="#523B9F" color="white" height="48px" borderRadius="4px" fontSize="13px" />
      </Link>
    </div>
  </div>
);

export default PasswordChangeSuccessModal;
